export const ACTIONS = {
    BUTTON: 'BUTTON',
    COL1: 'COL1',
    COL2: 'COL2',
    CLEAR: 'CLEAR'
};

export default ACTIONS;